import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSolar: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSolar"><Path d="M12 15.5H19.5L21.5 20.5H12M12 15.5H4.5L2.5 20.5H12M12 15.5V20.5M12 9.5V11.5M18.5 3.5H20.5M3.5 3.5H5.5M7 8L5.5 9.5M17 8L18.5 9.5M15.5 3.5C15.5 5.433 13.933 7 12 7C10.067 7 8.5 5.433 8.5 3.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSolar;
